import { mapState } from 'vuex'
import RadioRow from '@/components/common/RadioRow/RadioRow'
import DateSpan from '@/components/common/DateSpan/DateSpan'
import TheBreadcrumbs from '@/components/common/TheBreadcrumbs/TheBreadcrumbs'
import DataTable from '@/components/common/DataTable/DataTable'
import AnalyzeCondition from '@/components/common/Result/AnalyzeCondition/AnalyzeCondition'
import _ from 'lodash'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Constants from '@/utils/Constants'
import { sanitizeArray } from '@/utils/sanitize'

export default {
  name: 'PageHistoryList',
  layout: 'LayoutDefault',
  components: {
    RadioRow: RadioRow,
    DateSpan: DateSpan,
    TheBreadcrumbs: TheBreadcrumbs,
    HistoryDataTable: DataTable,
    AnalyzeCondition: AnalyzeCondition
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'ダッシュボード',
        disabled: false,
        href: '/'
      },
      {
        text: '分析履歴一覧',
        disabled: true,
        href: ''
      }
    ],
    rules: [v => v.length <= 200 || '最大200文字'],
    searchWord: '',
    company: 0,
    companies: [
      { text: 'A会社', value: '1' },
      { text: 'B会社', value: '2' }
    ],
    menuLabel: '選択',
    showEditDialog: false,
    dialog: false,
    editData: {
      id: -1,
      publishSetting: 'Publish',
      memo: ''
    },
    headers: [
      { text: 'id', align: 'left', value: 'id' },
      { text: '分析名', align: 'left', value: 'analyze_target_name', type: 'link' },
      { text: 'ステータス', align: 'left', value: 'status' },
      { text: 'メモ', align: 'left', value: 'memo', format_complex: true, format_length: 20, splitter: '@SPLITTER@' },
      { text: '分析時間', align: 'left', value: 'analyze_timestamp', html: true },
      { text: '共有設定', align: 'left', value: 'publish_setting' },
      { text: '作成者', align: 'left', value: 'user_name' },
      { text: '分析種類', align: 'left', value: 'analyze_type' },
      { text: '閲覧', align: 'left', value: 'read_status' }
    ],
    menuHeader: { text: '操作', align: 'left', sortable: false, value: 'menuItems', type: 'menu' },
    showConditionDialog: false,
    // selectedConditionjp: null,
    selectedAnalyzeTargetCode: null,
    selectedJobId: null,
    pagination: {},
    reloadTimerId: null,
    paramUserId: '',
    paramAnalyzeTargetCode: '',
    paramPublishSetting: '',
    paramAnalyzeType: '',
    paramAnalyzeTerm: { from: '', to: '' },
    paramReadStatus: '',

    columns: [
      'id',
      'name',
      'email'
    ],
    data: [
      {
        'id': 1,
        'name': 'sample1',
        'email': 'sample1@example.com',
        'group_name': '人事部'
      },
      {
        'id': 2,
        'name': 'sample2',
        'email': 'sample2@example.com',
        'group_name': '人事部'
      },

      {
        'id': 3,
        'name': 'sample3',
        'email': 'sample3@example.com',
        'group_name': '経理部'
      },
      {
        'id': 4,
        'name': 'sample4',
        'email': 'sample4@example.com',
        'group_name': '総務部'
      }
    ],
    options: {
      headings: {
        id: 'id',
        name: '名前',
        email: 'メールアドレス'
      },
      sortable: [
        'id', 'name'
      ],
      texts: {
        filterPlaceholder: '検索する'
      }
    },
    isSmallScreen: false,
    selectionState: { selectedCount: 0, disableAllSelected: true }
  }),
  created () {
    if (this.api_message) {
      // 権限不足（分析履歴参照権限不足）の場合、分析履歴一覧画面へ遷移してメッセージを表示する
      this.g_addAlert(this.api_message, 'error', 0)
      this.$store.dispatch('routerdata/setApiMessage', null)
    }
    console.log('HistoryList created')
    this.$store.dispatch('pagehistorylist/getUserList')
    this.doReload()
  },
  computed: {
    ...mapState({
      list: state => state.pagehistorylist.list,
      selectedConditionjp: state => state.pagehistorylist.current_condition_jp,
      currentPage: state => state.pagehistorylist.current_page,
      userList: state => state.pagehistorylist.user_list,
      message: state => state.pagehistorylist.message
    }),
    analyzeTargetList () {
      return [{ 'code': '', 'name': '分析種類を選択' }].concat(
        _.filter(JSON.parse(Vue.localStorage.get('menu')), (item) => {
          return _.startsWith(item.code, 'IF')
        }))
    },
    history_publish_setting_flag () {
      return Constants.getContract('history_publish_setting_flag')
    },
    is_private () {
      // 1945
      // 契約企業設定で
      // 分析予約共有
      // 分析履歴共有
      // いずれかがONの場合は「ユーザ選択、共有設定」の条件が有効。
      // どちらもOFFの場合は「ユーザ選択、共有設定」を無効とする。
      return Constants.getContract('history_publish_setting_flag') === 0 &&
        Constants.getContract('reservation_publish_setting_flag') === 0
    },
    // サニタイズされた分析履歴リスト
    sanitizedListItems () {
      if (!this.list.items) return []

      return sanitizeArray(this.list.items, ['memo', 'origin_memo'])
    },
    ...mapState({
      api_message: state => state.routerdata.apiMessage
    })
  },
  destroyed () {
    clearTimeout(this.reloadTimerId)
    this.$store.dispatch('analyzeresult/resetData')
    this.$store.dispatch('routerdata/setApiMessage', null)
  },
  methods: {
    onResize () {
      this.isSmallScreen = window.innerWidth < 1200
      console.log(this.isSmallScreen)
    },
    onSelectionChanged (selection, disableAllSelected) {
      this.selectionState = {
        selectedCount: selection.length,
        disableAllSelected: disableAllSelected
      }
    },
    doReload () {
      if (this.reloadTimerId) {
        this.getHistoryList(
          this.currentPage,
          this.pagination.sortBy,
          this.pagination.descending,
          this.paramUserId,
          this.paramAnalyzeTargetCode,
          this.paramPublishSetting,
          this.paramAnalyzeType,
          this.paramAnalyzeTerm.from,
          this.paramAnalyzeTerm.to,
          this.paramReadStatus
        )
      }
      this.reloadTimerId = setTimeout(this.doReload, 30000)
    },
    updateSearch () {
      this.getHistoryList(
        this.currentPage,
        this.pagination.sortBy,
        this.pagination.descending,
        this.paramUserId,
        this.paramAnalyzeTargetCode,
        this.paramPublishSetting,
        this.paramAnalyzeType,
        this.paramAnalyzeTerm.from,
        this.paramAnalyzeTerm.to,
        this.paramReadStatus
      )
    },
    onPagination (pagination) {
      this.resetTimer()
      this.pagination = _.cloneDeep(pagination)
      this.getHistoryList(
        pagination.page,
        pagination.sortBy,
        pagination.descending,
        this.paramUserId,
        this.paramAnalyzeTargetCode,
        this.paramPublishSetting,
        this.paramAnalyzeType,
        this.paramAnalyzeTerm.from,
        this.paramAnalyzeTerm.to,
        this.paramReadStatus
      )
      VueScrollTo.scrollTo('body', 500)
    },
    onDeleteItems (items) {
      let deleteIds = _.map(items, 'id')
      this.$store.dispatch('pagehistorylist/doDelete', deleteIds)
      // console.log(deleteIds)
      // this.updateSearch()
    },
    onSelectedMenuItem (items, menuItem) {
      if (menuItem.target === 'result') {
        // let resultID = items.analyze_target_code.substr(4, 3)
        // debugger
        // let name = 'Page' + items.analyze_target_code + 'Result'
        // const routes = []
        // routes.push({
        //   path: '/result',
        //   name: 'Page' + items.analyze_target_code + 'Result',
        //   // dynamic import
        //   component: require('@/pages/PageResult/' + name + '/' + name).default,
        //   meta: { requiredAuth: true }
        // })
        // this.$router.addRoutes(routes)
        // this.$router.push({ path: routes[0].path })
      } else {
        console.log(items)
        this.showEditDialog = true
        this.editData.memo = items.origin_memo === null ? '' : items.origin_memo
        if (this.history_publish_setting_flag === 0) {
          this.editData.publishSetting = '0'
        } else {
          if (items.publish_setting === 'Public') {
            this.editData.publishSetting = '1'
          } else {
            this.editData.publishSetting = '0'
          }
        }
        this.editData.id = items.id
      }
    },
    onUpdateHistory () {
      this.doUpdateHistory(this.editData)
      this.showEditDialog = false
    },
    getHistoryList (pageNo, sortField, sortType, paramUserId,
      paramAnalyzeTargetCode, paramPublishSetting, paramAnalyzeType,
      paramAnalyzeTermFrom, paramAnalyzeTermTo, paramReadStatus) {
      this.$store.dispatch('pagehistorylist/getHistoryList', {
        pageNo: pageNo,
        sortField: sortField,
        sortType: sortType,
        userId: paramUserId,
        analyzeTargetCode: paramAnalyzeTargetCode,
        publishSetting: paramPublishSetting,
        analyzeType: paramAnalyzeType,
        analyzeTermFrom: paramAnalyzeTermFrom,
        analyzeTermTo: paramAnalyzeTermTo,
        readStatus: paramReadStatus
      })
    },
    doUpdateHistory (editData) {
      this.$store.dispatch('pagehistorylist/doUpdate', editData)
    },
    onClickItem (item) {
      this.selectedAnalyzeTargetCode = item.analyze_target_code
      this.selectedJobId = item.job_id
      this.$store.dispatch('pagehistorylist/getDetail', item.id).then(() => {
        if (this.selectedConditionjp) {
          this.showConditionDialog = true
        } else {
          this.g_addAlert(this.message, 'error', 0)
        }
      })
    },
    onConditionClose () {
      this.showConditionDialog = false
    },
    onSearch () {
      this.resetTimer()
      this.updateSearch()
    },
    onReset () {
      this.resetTimer()
      this.paramUserId = ''
      this.paramAnalyzeTargetCode = ''
      this.paramPublishSetting = ''
      this.paramAnalyzeType = ''
      this.paramAnalyzeTerm = { from: '', to: '' }
      this.paramReadStatus = ''
      this.getHistoryList(
        1,
        null,
        null,
        this.paramUserId,
        this.paramAnalyzeTargetCode,
        this.paramPublishSetting,
        this.paramAnalyzeType,
        this.paramAnalyzeTerm.from,
        this.paramAnalyzeTerm.to,
        this.paramReadStatus
      )
    },
    resetTimer () {
      if (this.reloadTimerId) {
        clearTimeout(this.reloadTimerId)
        this.reloadTimerId = setTimeout(this.doReload, 30000)
      }
    }
  },
  metaInfo () {
    this.$store.dispatch('meta/set', {
      title: '分析履歴一覧',
      meta: [
        {
          name: 'description',
          content: '分析履歴一覧'
        }
      ]
    })
    return this.$store.getters['meta/get']
  }
}
